import script from "./SmsApp.vue?vue&type=script&async=true&setup=true&lang=ts"
export * from "./SmsApp.vue?vue&type=script&async=true&setup=true&lang=ts"

import "./SmsApp.vue?vue&type=style&index=0&id=4a92eb6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a92eb6a"]])

export default __exports__